"use client";

import React from "react";
import { ShieldCheck, Award, Handshake, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const valuesData = [{
  title: "Zuverlässigkeit",
  description: "Wir halten unsere Zusagen und Termine ein. Auf uns können Sie sich bei jedem Projekt voll und ganz verlassen.",
  icon: ShieldCheck
}, {
  title: "Qualität",
  description: "Höchste handwerkliche Standards und beste Materialien garantieren langlebige und erstklassige Ergebnisse.",
  icon: Award
}, {
  title: "Fairness",
  description: "Transparente Preise, klare Absprachen und eine ehrliche Beratung auf Augenhöhe sind für uns selbstverständlich.",
  icon: Handshake
}, {
  title: "Flexibilität",
  description: "Wir passen uns Ihren individuellen Bedürfnissen an und finden für jede bauliche Herausforderung die passende Lösung.",
  icon: Zap
}];
export default function ValuesSection() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="values-section" className="bg-background py-12 md:py-16 overflow-hidden">
      <div className="page-container">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground uppercase tracking-wider mb-6">
            Unsere Werte
          </h2>
          <Separator className="w-24 h-1 bg-accent mx-auto mb-6" />
          <p className="text-lg md:text-xl text-muted-foreground font-sans">
            Wofür wir stehen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {valuesData.map((value, index) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={index} data-index={index} ref={cardRef} className={`transition-all duration-700 ease-out`} style={{
            opacity: isCardVisible ? 1 : 0,
            transform: isCardVisible ? "translateY(0)" : "translateY(32px)",
            transitionDelay: `${index * 150}ms`
          }}>
                <Card className="h-full border-border/50 shadow-md hover:shadow-lg transition-shadow duration-300 bg-card">
                  <CardHeader className="flex flex-col items-center text-center pb-2 pt-4">
                    <div className="w-16 h-16 rounded-2xl bg-accent flex items-center justify-center mb-6 shadow-sm">
                      <value.icon className="w-8 h-8 text-accent-foreground" />
                    </div>
                    <CardTitle className="text-xl font-default text-foreground">
                      {value.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center pb-4">
                    <p className="text-muted-foreground font-sans leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}